import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { Treeselect } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import _debounce from 'lodash/debounce';
import { useListOptionsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Industry',
  emits: ['input'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var _useListOptionsQuery = useListOptionsQuery({
        id: 13579135
      }),
      result = _useListOptionsQuery.result,
      loading = _useListOptionsQuery.loading;
    var naceOptionTree = computed(function () {
      var _result$value$listOpt, _result$value;
      return (_result$value$listOpt = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listOptions) !== null && _result$value$listOpt !== void 0 ? _result$value$listOpt : [];
    });
    var getOptionExternalId = function getOptionExternalId(node) {
      return (node === null || node === void 0 ? void 0 : node.externalId) || (node === null || node === void 0 ? void 0 : node.id);
    };
    var optionIdMap = computed(function () {
      var _result$value$listOpt2, _result$value2;
      var externalToInternal = new Map();
      var internalToExternal = new Map();
      var stack = _toConsumableArray((_result$value$listOpt2 = (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.listOptions) !== null && _result$value$listOpt2 !== void 0 ? _result$value$listOpt2 : []);
      while (stack.length > 0) {
        var option = stack.pop();
        if (!option) {
          continue;
        }
        var externalId = getOptionExternalId(option);
        var internalId = option.id;
        if (externalId !== undefined && externalId !== null && internalId != null) {
          externalToInternal.set(String(externalId), internalId);
          internalToExternal.set(String(internalId), externalId);
        }
        if (Array.isArray(option.children) && option.children.length > 0) {
          stack.push.apply(stack, _toConsumableArray(option.children));
        }
      }
      return {
        externalToInternal: externalToInternal,
        internalToExternal: internalToExternal
      };
    });
    var normalizerNace = function normalizerNace(node) {
      var externalId = getOptionExternalId(node);
      return {
        id: externalId,
        label: "".concat(externalId, " - ").concat(node.label),
        children: node.children
      };
    };
    var attrs = useAttrs();
    var debouncedEmit = _debounce(function (event, value) {
      emit(event, value);
    }, 100);
    var onInput = function onInput(val) {
      var mapExternalValueToInternal = function mapExternalValueToInternal(value) {
        var _optionIdMap$value$ex;
        return (_optionIdMap$value$ex = optionIdMap.value.externalToInternal.get(String(value))) !== null && _optionIdMap$value$ex !== void 0 ? _optionIdMap$value$ex : value;
      };
      var normalizedVal = attrs.multiple ? (val !== null && val !== void 0 ? val : []).map(mapExternalValueToInternal) : mapExternalValueToInternal(val);
      var comparator = function comparator(a, b) {
        return a == b;
      };
      if (attrs.multiple) {
        comparator = function comparator(a, b) {
          return _.isEqual(_.sortBy(a), _.sortBy(b));
        };
      }
      if (!comparator(attrs.value, normalizedVal)) {
        debouncedEmit('input', normalizedVal);
      }
    };
    var patchedValue = computed(function () {
      // we patch the value to prevent from showing "undefined - undefine" because <treeselect expect :value="null" for invalid value
      // we might need a better one if we have valid value of empty string: ''

      if (attrs.value === '' || !attrs.value) {
        return null;
      }
      var mapInternalValueToExternal = function mapInternalValueToExternal(value) {
        var _optionIdMap$value$in;
        return (_optionIdMap$value$in = optionIdMap.value.internalToExternal.get(String(value))) !== null && _optionIdMap$value$in !== void 0 ? _optionIdMap$value$in : value;
      };
      if (attrs.multiple) {
        var _attrs$value;
        return ((_attrs$value = attrs.value) !== null && _attrs$value !== void 0 ? _attrs$value : []).map(mapInternalValueToExternal);
      }
      return mapInternalValueToExternal(attrs.value);
    });
    return {
      __sfc: true,
      result: result,
      loading: loading,
      naceOptionTree: naceOptionTree,
      getOptionExternalId: getOptionExternalId,
      optionIdMap: optionIdMap,
      normalizerNace: normalizerNace,
      emit: emit,
      attrs: attrs,
      debouncedEmit: debouncedEmit,
      onInput: onInput,
      patchedValue: patchedValue,
      Treeselect: Treeselect
    };
  }
});